import dayjs from 'dayjs';

export function getWeekdayOccurrenceInMonth(date: Date) {
  const input = dayjs(date);

  const dayOfWeek = input.day();
  const firstDayOfMonth = input.startOf('month');
  const firstDayWeekday = firstDayOfMonth.day();

  // Calculate the date of the first occurrence of this weekday in the month.
  // If 'firstDayWeekday' is the weekday of the 1st of the month,
  // we add the offset to find the first occurrence of 'dayOfWeek'.
  const firstOccurrence = ((7 + dayOfWeek - firstDayWeekday) % 7) + 1;

  // The given date's day of the month
  const dayOfMonth = input.date();

  // Now we see how many times that weekday has occurred up to 'dayOfMonth'.
  // The nth occurrence is how many full weeks have passed since the first occurrence, plus 1.
  const occurrence = Math.floor((dayOfMonth - firstOccurrence) / 7) + 1;

  return { dayOfWeek, occurrence };
}
